import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customPercentage',
})
export class CustomPercentagePipe implements PipeTransform {
  transform(value: number, decimals = 2): string {
    if (Number.isInteger(value)) {
      return value + '%';
    }
    return value.toFixed(decimals) + '%';
  }
}
